/**
 * Global toast event system.
 *
 * Uses the same CustomEvent / window.dispatchEvent pattern as
 * SESSION_EXPIRED_EVENT in axiosClient.ts.
 *
 * Any component can call `showGlobalToast(...)` and the Snackbar
 * rendered in MainLayout will display it at the top of the screen.
 */

export const GLOBAL_TOAST_EVENT = 'app:global-toast';

export type GlobalToastSeverity = 'success' | 'error' | 'warning' | 'info';

export interface GlobalToastDetail {
  message: string;
  severity: GlobalToastSeverity;
}

/**
 * Dispatch a global toast event.
 * MainLayout listens for this and renders the Snackbar.
 */
export function showGlobalToast(
  message: string,
  severity: GlobalToastSeverity = 'success',
) {
  window.dispatchEvent(
    new CustomEvent<GlobalToastDetail>(GLOBAL_TOAST_EVENT, {
      detail: { message, severity },
    }),
  );
}
